import { useState } from 'react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import BedCleanForm from './BedCleanForm';

import { useOnSubmit, useOnEdit } from '~hooks';
import { removeEmptyKeys } from '../validations';

const BedClean = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const [externalValidations, setExternalValidations] = useState([]);

  const validate = values => {
    const errors = {};

    externalValidations.forEach(validation => {
      const value = values[validation.name];
      const error = validation.getError(value);
      if (error) {
        errors[validation.name] = error;
      }
    });

    if (values.cleanupType === 'PATIENT_BED') {
      // TODO: check location as well
      if (!values.room) {
        errors.room = 'Vaadittu';
      }

      if (!values.urgency) {
        errors.urgency = 'Vaadittu';
      }

      if (values.precautions === 'YES' && !values.precautionClass) {
        errors.precautionClass = 'Vaadittu';
      }

      if (!values.plasticWrap) {
        errors.plasticWrap = 'Vaadittu';
      }
    } else if (values.cleanupType === 'SEPARATE_BED') {
      if (!values.nearestRoom) {
        errors.nearestRoom = 'Vaadittu';
      }

      if (!values.urgency) {
        errors.urgency = 'Vaadittu';
      }

      if (!values.plasticWrap) {
        errors.plasticWrap = 'Vaadittu';
      }
    } else if (values.cleanupType === 'OTHER_CLEANUP') {
      if (values.otherCleanupType?.length < 1) {
        errors.otherCleanupType = 'Vaadittu';
      }
    } else {
      errors.cleanupType = 'Virheellinen siivoustyyppi';
    }

    return removeEmptyKeys(errors);
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      validate={validate}
      initialValues={{
        cleanupType: 'PATIENT_BED',
        otherCleanupType: null,
        room: null,
        location: null,
        nearestRoom: null,
        urgency: 'DFLT',
        precautions: 'NO',
        precautionClass: null,
        plasticWrap: 'NO',
        contactPhone: '',
      }}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;

        await method({
          fields: {
            ...values,
            // room: values.room.value,
            // location: values.location.value,
          },
          setSubmitting,
          formId,
          orderId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Vuodesiivous"
          formik={formikProps}
          Component={BedCleanForm}
          setExternalValidations={setExternalValidations}
        />
      )}
    </Formik>
  );
};

export default BedClean;
